import { ApplicationRoles } from '../../../constants/applicationRoles.ts';
import applicationRoutes from '../../../constants/applicationRoutes.ts';
import Layout from '../../../app/Layout.tsx';
import { RouteAuthenticationRequirement, RouteItem } from '@invara-dev/react-base';

export const MirNavItems: RouteItem = {
  text: 'MIR',
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: [ApplicationRoles.mirAdmin],
  layout: <Layout />,

  subItems: [
    {
      text: 'MIR File Report',
      path: applicationRoutes.mir.mirFileReport,
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      allowedRoles: [ApplicationRoles.mirAdmin],
      async lazy() {
        const component = await import('../../../features/mirAdmin/mirFileReport/mirFileReport.tsx');
        return { Component: component.MirFileReport };
      }
    }
  ]
};
